import React from 'react'

import { bool, string } from 'prop-types'

import CTABanner from 'Pods/Shared/AiLanding/CTABanner/CTABanner'
import FAQs from 'Pods/Shared/AiLanding/FAQs/FAQs'
import SignInModalHost from 'Pods/Shared/AiLanding/SignInModalHost/SignInModalHost'

import CenteredTitle from './Components/CenteredTitle/CenteredTitle'
import CommunityGallery from './Components/CommunityGallery/CommunityGallery'
import CreateWithAi from './Components/CreateWithAi/CreateWithAi'
import GoToTop from './Components/GoToTop/GoToTop'
import UpgradeHeader from './Components/UpgradeHeader/UpgradeHeader'

const FAQ_TITLE = 'Frequently Asked Questions'
const FAQ_SUBTITLE = 'Find your answers here.'

const FAQ_ITEMS = [
  {
    question: 'What counts toward my 25 monthly uses?',
    answer: 'AI generations and Marketplace downloads both count toward your monthly allowance.',
  },
  {
    question: 'What happens when I reach my monthly limit?',
    answer: "You'll need to wait until your monthly allowance resets. Additional usage "
      + 'options will be available soon.',
  },
  {
    question: 'Can I download Marketplace models and edit them with AI?',
    answer: 'Yes. You can enhance, edit, and customize your own models as well as eligible '
      + 'Marketplace models.',
  },
  {
    question: 'Do unused monthly uses roll over?',
    answer: 'No. Unused generations and downloads expire at the end of each billing cycle.',
  },
  {
    question: 'Can I cancel my Subscription at any time?',
    answer: 'You can cancel without a cancellation fee within the first 45 days. After that, an '
      + 'early cancellation fee equal to 50% of the remaining contract balance will apply.',
  },
]

const CTA_TITLE = 'Ready to Start Creating?'
const CTA_SUBTITLE = 'Create custom 3D models with CGTrader AI, and access premium downloads anytime.'

// This is a cacheable fast page, so per-user 3D Studio subscription state is not
// available at SSR time -- it is delivered client-side via window.pageConfig
// (built in has_fast_application_state_helpers.rb, flushed by /load-services.js).
// Sections read only the fields they need with usePageConfig (see UpgradeHeader),
// so this root stays a plain layout. Three non-user-specific values are threaded
// from SSR props (see react_props_ai_sub_landing): extractingCoreStyles, an
// SSR-render-time flag (false outside extraction) that lets per-user sections
// force-render during the critical-CSS extraction pass so their styles are
// captured; subscriptionPaymentFormUrl, the absolute payment-form URL the CTA falls back to
// before per-user page config hydrates (and for signed-out visitors); and
// freeTrialAvailable, the class-level trial-pool flag that lets UpgradeHeader render
// its signed-out layout at SSR (matching hydration) instead of popping in afterwards.
function AiSubLanding({
  locale = 'en',
  extractingCoreStyles = false,
  subscriptionPaymentFormUrl = '',
  freeTrialAvailable = false,
}) {
  return (
    <div className="ai-sub-landing">
      <UpgradeHeader
        extractingCoreStyles={extractingCoreStyles}
        subscriptionPaymentFormUrl={subscriptionPaymentFormUrl}
        freeTrialAvailable={freeTrialAvailable}
      />
      <CreateWithAi />
      <CenteredTitle />
      <CommunityGallery extractingCoreStyles={extractingCoreStyles} />
      <FAQs
        title={FAQ_TITLE}
        subtitle={FAQ_SUBTITLE}
        items={FAQ_ITEMS}
        idPrefix="ai-sub-landing-faq"
      />
      <CTABanner
        title={CTA_TITLE}
        subtitle={CTA_SUBTITLE}
        subscriptionPaymentFormUrl={subscriptionPaymentFormUrl}
      />
      <GoToTop />
      <SignInModalHost locale={locale} />
    </div>
  )
}

AiSubLanding.propTypes = {
  locale: string,
  extractingCoreStyles: bool,
  subscriptionPaymentFormUrl: string,
  freeTrialAvailable: bool,
}

export default AiSubLanding
